export const exporter = (data, fileName) => {
    const element = document.createElement("a");
    const file = new Blob([data.toString().replaceAll(',', '')], {
        type: "text/plain"
    });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
};